<form #form="ngForm">
    <ng-container *ngIf="goal">
        <div class="app-grid">
            <app-segment-header title="performance.goal-details.title"></app-segment-header>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'performance.goal-details.formFields.title.label' | translate }}</mat-label>
                <input
                    type="text"
                    name="title"
                    required
                    placeholder="{{ 'performance.goal-details.formFields.title.placeholder' | translate }}"
                    #title="ngModel"
                    [(ngModel)]="goal.title"
                    matInput
                />
                <mat-error *ngIf="title.invalid">{{ title.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-details.formFields.type.label' | translate
                }}</mat-label>
                <mat-select name="is_shared" required #isShared="ngModel" [(ngModel)]="goal.isShared">
                    <mat-option value="">{{
                        'performance.goal-details.formFields.type.options.selectAnOption' | translate
                    }}</mat-option>
                    <mat-option [value]="true">{{
                        'performance.goal-details.formFields.type.options.sharedGoal' | translate
                    }}</mat-option>
                    <mat-option [value]="false">{{
                        'performance.goal-details.formFields.type.options.perEmployee' | translate
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="isShared.invalid">{{ isShared.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field class="columns-12">
                <mat-label>{{ 'performance.goal-details.formFields.description.label' | translate }}</mat-label>
                <textarea name="description" [(ngModel)]="goal.description" matInput></textarea>
            </mat-form-field>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'performance.goal-details.formFields.frequency.label' | translate
                }}</mat-label>
                <mat-select name="reoccuring" [(ngModel)]="goal.reoccuring">
                    <mat-option value="">
                        {{ 'performance.goal-details.formFields.frequency.options.selectAnOption' | translate }}
                    </mat-option>
                    <mat-option value="never">
                        {{ 'performance.goal-details.formFields.frequency.options.once' | translate }}
                    </mat-option>
                    <mat-option value="daily">
                        {{ 'performance.goal-details.formFields.frequency.options.daily' | translate }}
                    </mat-option>
                    <mat-option value="weekly">
                        {{ 'performance.goal-details.formFields.frequency.options.weekly' | translate }}
                    </mat-option>
                    <mat-option value="monthly">
                        {{ 'performance.goal-details.formFields.frequency.options.monthly' | translate }}
                    </mat-option>
                    <mat-option value="quarterly">
                        {{ 'performance.goal-details.formFields.frequency.options.quarterly' | translate }}
                    </mat-option>
                    <mat-option value="semiannually">
                        {{ 'performance.goal-details.formFields.frequency.options.semiannually' | translate }}
                    </mat-option>
                    <mat-option value="annually">
                        {{ 'performance.goal-details.formFields.frequency.options.annually' | translate }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <app-segment-header title="performance.goal-details.scheduleSectionTitle"></app-segment-header>
            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'performance.goal-details.formFields.startAt.label' | translate }}</mat-label>
                <input
                    name="start_at"
                    #start_at="ngModel"
                    required
                    [ngModel]="goal.startAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="goal.startAt = $event"
                    placeholder="{{ 'performance.goal-details.formFields.startAt.placeholder' | translate }}"
                    [matDatepicker]="startAtPicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="startAtPicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #startAtPicker></mat-datepicker>
                <mat-error *ngIf="start_at.invalid">{{ start_at.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-6 small-columns-12">
                <mat-label>{{ 'performance.goal-details.formFields.dueDate.label' | translate }}</mat-label>
                <input
                    name="due_at"
                    #due_at="ngModel"
                    [ngModel]="goal.dueAt | appDate: 'yyyy-MM-dd'"
                    (ngModelChange)="goal.dueAt = $event"
                    placeholder="{{ 'performance.goal-details.formFields.dueDate.placeholder' | translate }}"
                    required
                    [matDatepicker]="dueAtPicker"
                    matInput
                />
                <mat-datepicker-toggle matSuffix [for]="dueAtPicker">
                    <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #dueAtPicker></mat-datepicker>
                <mat-error *ngIf="due_at.invalid">{{ due_at.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
